import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px 0 56px;

  @media (max-width: 1280px) {
    padding: 32px 16px 56px;
  }
`;

export const ErrorMessageContainer = styled.div`
  padding: 40px 16px;

  h2 {
    color: #666666;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 28px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PropertyTitle = styled.h1`
  font-size: 32px;
  line-height: 1.2;
  color: #2d2d2d;
  font-weight: 700;

  @media (max-width: 767px) {
    font-size: 26px;
  }
`;

export const PropertyCode = styled.p`
  color: #7a7a7a;
  font-size: 15px;
`;

export const BackButton = styled.button`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #dd6435;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const HeaderAside = styled.div`
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;

  > span {
    color: #666666;
    font-size: 14px;
  }

  @media (max-width: 900px) {
    align-items: flex-start;
  }
`;

export const StatusBadge = styled.span<{
  variant?: "default" | "success" | "warning" | "danger";
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 34px;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  text-transform: capitalize;

  background: ${({ variant }) => {
    switch (variant) {
      case "success":
        return "#e8f7ed";
      case "warning":
        return "#fff5e8";
      case "danger":
        return "#fdecec";
      default:
        return "#f3f4f6";
    }
  }};

  color: ${({ variant }) => {
    switch (variant) {
      case "success":
        return "#1f7a3d";
      case "warning":
        return "#b26a00";
      case "danger":
        return "#b42318";
      default:
        return "#555555";
    }
  }};
`;

export const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const HeroCard = styled.section`
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfb 100%);
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
`;

export const HeroCardTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2d2d2d;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export const HeroHighlights = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: 14px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const HighlightItem = styled.div`
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  padding: 16px;

  strong {
    display: block;
    color: #666666;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  span {
    color: #2d2d2d;
    font-size: 18px;
    font-weight: 700;
  }
`;

export const MainGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionCard = styled.section`
  width: 100%;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    padding: 18px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 21px;
  font-weight: 700;
  color: #2d2d2d;
  margin-bottom: 20px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 16px 24px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  strong {
    color: #666666;
    font-size: 13px;
    font-weight: 600;
  }

  span,
  a,
  p {
    color: #2d2d2d;
    font-size: 15px;
    line-height: 1.5;
    word-break: break-word;
  }

  a {
    color: #6ea5ff;
  }
`;

export const PhotosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 14px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(160px, 1fr));
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
`;

export const PhotoCard = styled.div`
  width: 100%;
  height: 220px;
  border-radius: 14px;
  overflow: hidden;
  background: #f4f4f4;
  border: 1px solid #eeeeee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 767px) {
    height: 150px;
  }
`;

export const PeopleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const PersonCard = styled.div`
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 14px;
  padding: 18px;

  h3 {
    color: #2d2d2d;
    font-size: 17px;
    font-weight: 700;
    margin-bottom: 14px;
  }

  > div + div {
    margin-top: 12px;
  }
`;

export const EmptyStateCard = styled.div`
  background: #fff8f4;
  border: 1px solid #f1d4c6;
  border-radius: 14px;
  padding: 18px;

  p {
    color: #8a5a44;
    font-size: 15px;
    line-height: 1.6;
  }
`;

export const FinanceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 16px 24px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const FinanceCard = styled.div`
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 14px;
  padding: 18px;

  h3 {
    color: #2d2d2d;
    font-size: 17px;
    font-weight: 700;
    margin-bottom: 14px;
  }

  > div + div {
    margin-top: 12px;
  }
`;